// checks if user is authenticated, if not redirects to login page
import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../UserContext";

const PrivateRoute = ({ children, requiredRoles }) => {
    const { user } = useUser();

    const hasRole = (user, requiredRoles) => {
        if (!user) return false;
        if (user.is_superuser) return true; // superuser has access to all routes
        // return user.groups.includes(requiredRoles);
        return requiredRoles.some((role) => user.groups.includes(role));
    };

    if (!user) {
        // user is not authenticated, redirect to login page
        return <Navigate to="/login" />;
    }

    if (requiredRoles && !hasRole(user, requiredRoles)) {
        // user is not authorized, redirect to home page
        return <Navigate to="not-authorized" />;
    }

    return children;
};

export default PrivateRoute;